import { userSelectors } from '../../../actions/user/redux/selectors';
import { Avatar, Box, Typography, useAppSelector } from '../../../base';
import UserManagementMenu from './UserManagementMenu';

const UserPreview = () => {
    const myUser = useAppSelector(userSelectors.getMyUser);
    const userFullName = `${myUser?.firstName || ''} ${myUser?.lastName || ''}`;

    return (
        <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            width="100%"
            paddingInlineEnd={2}
        >
            <Avatar
                name={userFullName}
                src={myUser?.profilePicture}
                sx={{ height: '35px', width: '35px', flexShrink: 0 }}
            />
            <Box
                flex={1}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                marginInlineStart={2}
            >
                <Box display="flex" alignItems="center" width="100%">
                    <Box
                        sx={{ flex: '0 1 auto', maxWidth: 'calc(100% - 40px)' }}
                    >
                        <Typography
                            variant="body2"
                            component="span"
                            fontWeight={600}
                            sx={{ fontSize: 'clamp(0.75rem, 2vw, 0.875rem)' }}
                        >
                            {userFullName}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            flexShrink: 0,
                            marginInlineEnd: 1,
                            display: 'flex',
                            alignItems: 'center',
                            minWidth: '32px',
                        }}
                    >
                        <UserManagementMenu />
                    </Box>
                </Box>
                <Typography variant="caption" color="text.secondary">
                    {myUser?.email || ''}
                </Typography>
            </Box>
        </Box>
    );
};

export default UserPreview;
